module.exports = __webpack_public_path__ + "static/media/9.50133c33.png";